import {showFromFade} from "../../js/Util";


const tariffsTabs = $(".js-tariffs-tabs");

if (tariffsTabs.length) {
    const tabsLinks = tariffsTabs.find("a");

    if (tabsLinks.length > 0) {
        tabsLinks.first().addClass("_active");
    }

    if (tabsLinks.length > 1) {
        tariffsTabs.addClass("_with-blue-border");
    }
}

$(".js-tariffs-tabs a").click(function (e) {
    e.preventDefault();

    let $el = $(this);
    let currentTab = $el.data("switch");

    $(".js-tariffs-tabs").find("._active").removeClass("_active");
    $el.addClass("_active");
    $(".js-tariffs-tabs-cards").find(".js-tariffs-tabs-cards-elem").hide();
    $("#" + currentTab).show();
});

if ($('.tariffs-tabs-card').length) {
    $('.tariffs-tabs-card').each((index, item) => {
        const start = $(document).width() >= 768 ? 'top bottom-=20%' : 'top bottom-=10%';
        showFromFade(item, start);
    });
}

if ($('.tariffs-tile').length) {
    $('.tariffs-tile').each((index, item) => {
        const start = $(document).width() >= 768 ? 'top bottom-=20%' : 'top bottom-=10%';
        showFromFade(item, start);
    });
}

if ($('.tariffs-included-item').length) {
    $('.tariffs-included-item').each((index, item) => {
        const start = $(document).width() >= 768 ? 'top bottom-=20%' : 'top bottom-=10%';
        showFromFade(item, start);
    });
}

if ($('.additional-servise').length) {
    $('.additional-servise').each((index, item) => {
        const start = $(document).width() >= 768 ? 'top bottom-=20%' : 'top bottom-=10%';
        showFromFade(item, start);
    });
}

if ($('.tariffs-help').length) {
    $('.tariffs-help').each((index, item) => {
        const start = $(document).width() >= 768 ? 'top bottom-=20%' : 'top bottom-=10%';
        showFromFade(item, start);
    });
}
